import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { Notes } from '../../models/notes'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { PortalGlobals } from '../../../portalglobals'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'

@Component({
    selector: 'notes',
    templateUrl: 'notes.component.html'
})

export class NotesComponent {

    orgName: string
    @Input() enrollment: EnrollmentViewModel = new EnrollmentViewModel()
    orgNamePDP: string

    constructor(public _global: PortalGlobals, private _currentUserGateway: CurrentUserGateway, private _enrollService: EnrollmentGateway) {
        if (this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser()
                .subscribe(user => {
                    if (user != null) {
                        this._global.currentUser = user
                        this.enrollment = this._enrollService.getEnrollmentViewModel()
                        //this.orgName = this._global.currentUser.insuranceCompanyName
                        this.setOrgname(this.enrollment.ISSINGLEGROUP)
                    }
                })
        }
        else {
            this.enrollment = this._enrollService.getEnrollmentViewModel()
            this.setOrgname(this.enrollment.ISSINGLEGROUP)
        }
       
    }
    setOrgname(ISSINGLEGROUP: boolean) {
        if (ISSINGLEGROUP === true) {
            this.orgName = this._global.currentUser.insuranceCompanyName
        }
        else {
            if (this._global.selectedPlanYear === 0 || this._global.selectedPlanYear === undefined) {
                if (sessionStorage.getItem("PLANYEAR") !== undefined) {
                    this._global.selectedPlanYear = Number(sessionStorage.getItem("PLANYEAR"))
                }
            }
            if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
                this.orgName = this._global.currentUser.insuranceCompanyName
            }
            else {
                //this.orgName = this._global.insuranceCompanyNameAetna
                this.orgName = this._global.insCompanyNameAetnaPdp
            }
        }
    }
 
   

   
}

